import React, { useEffect, useRef, useState } from 'react';
import { Field } from 'react-final-form';
import TextField from '@material-ui/core/TextField';

import GoogleMap from '../mapper/GoogleMap';
import { locationToDraggableMarker } from '../mapper/LocationHelper';

const LatLngInput = (props) => {
  const {
    prefix,
    labelPrefix = '',
    displayAtTop,
    displayInMiddle,
    record,
  } = props;
  const [lat, setLat] = useState(record[`${prefix}lat`]);
  const [lng, setLng] = useState(record[`${prefix}lng`]);
  const latFieldRef = useRef(null);
  const lngFieldRef = useRef(null);
  let onLatChange = () => {};
  let onLngChange = () => {};

  useEffect(() => {
    latFieldRef.current.focus();
  }, [lat]);

  useEffect(() => {
    lngFieldRef.current.focus();
  }, [lng]);

  const renderLatField = ({ input, label }) => {
    const { value, onChange, ...inputRest } = input;
    onLatChange = (e) => {
      setLat(e.target.value);
      onChange(e);
    };

    return (
      <TextField
        inputRef={latFieldRef}
        label={label}
        value={lat}
        onChange={onLatChange}
        {...inputRest}
      />
    );
  };

  const renderLngField = ({ input, label }) => {
    const { value, onChange, ...inputRest } = input;
    onLngChange = (e) => {
      setLng(e.target.value);
      onChange(e);
    };

    return (
      <TextField
        inputRef={lngFieldRef}
        label={label}
        value={lng}
        onChange={onLngChange}
        {...inputRest}
      />
    );
  };

  // https://github.com/fullstackreact/google-maps-react/issues/39#issuecomment-407369290
  const onMarkerDrag = (m1, m2, m3) => {
    const { latLng: newPosition } = m3;
    const newLat = newPosition.lat();
    const newLng = newPosition.lng();
    onLatChange({ target: { value: newLat } });
    onLngChange({ target: { value: newLng } });
  };

  const markerLocation = { lat, lng };
  const marker = locationToDraggableMarker({
    onMarkerDrag,
    ...markerLocation,
  });

  const container = {
    display: 'flex',
    flexDirection: 'column',
    width: '250px',
  };

  const googleMapStyle = {
    position: 'absolute',
    width: '500px',
    height: '300px',
    left: '550px',
  };

  if (displayAtTop) {
    googleMapStyle.top = '100px';
  } else if (displayInMiddle) {
    googleMapStyle.position = 'relative';
    googleMapStyle.marginBottom = '100px';
  } else {
    googleMapStyle.top = '260px';
  }

  return (
    <span style={container}>
      <Field
        name={`${prefix}lat`}
        component={renderLatField}
        label={`${labelPrefix}Latitude`}
      />
      &nbsp;
      <Field
        name={`${prefix}lng`}
        component={renderLngField}
        label={`${labelPrefix}Longitude`}
      />
      {lat && lng && (
        <GoogleMap
          style={googleMapStyle}
          zoom={17}
          mapType="satellite"
          centerLocation={markerLocation}
          markers={[marker]}
        />
      )}
    </span>
  );
};

export default LatLngInput;
